import React, { ReactNode } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import {
  Route, RouteComponentProps, Switch, withRouter,
} from 'react-router-dom';
import cartoucheFemme from '../../img/cartouche_femme.png';
import cartoucheHomme from '../../img/cartouche_homme.png';
import authApi from '../../network/api/authApi';
import compteApi from '../../network/api/compteApi';
import { CompteMonidentiteModifyDTO } from '../../network/api/types/compte/CompteMonidentiteModifyDTO';
import { Entity } from '../../network/api/types/compte/Entity';
import { MonIdentite } from '../../network/api/types/compte/MonIdentite';
import { UserDTO } from '../../network/api/types/compte/UserDTO';
import {
  COLLAB_INFO_DRAWER,
  CONNECTION_INFO_FORM,
  EMERGENCY_INFO_FORM,
  HOME_PAGE_ROUTE,
  PAIR_DEVICE_ONE,
  PAIR_DEVICE_TWO,
  PERSONAL_INFO_FORM,
  PROFESSIONAL_INFO_FORM,
  STRUCTURE_INFO_FORM,
} from '../../routes';
import { updateMyIndentity } from '../../services/user/userService';
import Drawer from '../common/modals/Drawer';
import { toastError } from '../common/Notification';
import PicturePopin from '../external/PicturePopin';
import Footer from '../layout/Footer';
import ConnectionInformation from './home/myAccount/connectionInformation/ConnectionInformation';
import EmergencyInformation from './home/myAccount/emergencyInformation/EmergencyInformation';
import MyAccount from './home/myAccount/MyAccount';
import PairDevice from './home/myAccount/pairDevice/PairDevice';
import PersonalInformation from './home/myAccount/personalInformation/PersonalInformation';
import CollaboratorsInformation from './home/myProInfo/CollaboratorsInformation/CollaboratorsInformation';
import MyProInfo from './home/myProInfo/MyProInfo';
import ProfessionalInformation from './home/myProInfo/professionalInformation/ProfessionalInformation';
import StructuresInformation from './home/myProInfo/structureInformation/StructuresInformation';

type Props = RouteComponentProps & {
  myIdentity?: MonIdentite;
  updateMyIndentity: (infos: CompteMonidentiteModifyDTO) => void;
  myUserDetails?: UserDTO;
  fetchEmergencyInfos?: () => void;
};

type State = {
  openImagePopin: boolean,
  updateNeededByEntity: Map<string, number>,
  myPseudo?: string,
};

class AccountHome extends React.Component<Props, State> {
  state: State = {
    openImagePopin: false,
    myPseudo: '',
    updateNeededByEntity: new Map(),
  };

  componentDidMount(): void {
    this.fetchMyPseudo();
  }

  openDrawer = (route: string, isManager?: boolean): void => {
    this.props.history.push({
      pathname: route,
      state: { isManager },
    });
  };

  updateCollaborateurStatut = (entity: Entity | undefined): void => {
    if (entity && entity.rattachement.manager) {
      compteApi.getCollaborateurStatut({ searchCode: '', idn: entity.rattachement.id, entite: entity.id })
        .then((response) => {
          this.setState((previousState) => {
            previousState.updateNeededByEntity.set(entity.id, response.value);
            return {
              updateNeededByEntity: previousState.updateNeededByEntity,
            };
          });
        })
        .catch(() => toastError(I18n.t('message.ERROR')));
    }
  };

  updateAndClose = (entityId: string) => {
    const entity = this.props.myUserDetails.entities
      .find((findEntity) => findEntity.id === entityId);
    this.updateCollaborateurStatut(entity);
    this.closeDrawer();
  };

  closeDrawer = (): void => {
    this.props.history.push(HOME_PAGE_ROUTE);
  };

  fetchMyPseudo = (): void => {
    authApi.fetchMyLoginStatus()
      .then((myLoginStatus) => this.setState({ myPseudo: myLoginStatus.pseudo }));
  };

  savePersonalInfos = (infos: CompteMonidentiteModifyDTO): void => {
    this.props.updateMyIndentity(infos);
  };

  getAvatar = (): string => {
    const cartouche = this.props.myIdentity?.civilite.toUpperCase() === 'MONSIEUR' ? cartoucheHomme : cartoucheFemme;
    return this.props.myIdentity?.photo || cartouche;
  };

  toogleImagePopin = (): void => {
    this.setState((previousState) => ({ openImagePopin: !previousState.openImagePopin }));
  };

  render(): ReactNode {
    const image = this.getAvatar();
    return (
      <div>
        {
          this.props.myIdentity
          && (
            <PicturePopin
              isOpen={this.state.openImagePopin}
              onClose={this.toogleImagePopin}
              image={image}
              myIdentity={this.props.myIdentity}
            />
          )
        }
        <Switch>
          <Route
            path={CONNECTION_INFO_FORM}
            render={() => (
              <Drawer
                onClose={this.closeDrawer}
                withCancelConfirmation
                isOpen
              >
                <ConnectionInformation
                  onClose={this.closeDrawer}
                  fetchPseudo={this.fetchMyPseudo}
                  pseudo={this.state.myPseudo}
                />
              </Drawer>
            )}
          />
          <Route
            path={PERSONAL_INFO_FORM}
            render={() => (
              <Drawer
                onClose={this.closeDrawer}
                withCancelConfirmation
                isOpen
              >
                <PersonalInformation
                  onClose={this.closeDrawer}
                  myIdentity={this.props.myIdentity}
                />
              </Drawer>
            )}
          />
          <Route
            path={EMERGENCY_INFO_FORM}
            render={() => (
              <Drawer
                onClose={this.closeDrawer}
                withCancelConfirmation
                isOpen
              >
                <EmergencyInformation
                  onClose={this.closeDrawer}
                  userDetails={this.props.myUserDetails}
                  fetchEmergencyInfos={this.props.fetchEmergencyInfos}
                />
              </Drawer>
            )}
          />
          <Route
            path={PAIR_DEVICE_ONE}
            render={() => (
              <Drawer
                onClose={this.closeDrawer}
                isOpen
                noVerticalMargin
              >
                <PairDevice onClose={this.closeDrawer} />
              </Drawer>
            )}
          />
          <Route
            path={PAIR_DEVICE_TWO}
            render={() => (
              <Drawer
                onClose={this.closeDrawer}
                isOpen
                noVerticalMargin
              >
                <PairDevice onClose={this.closeDrawer} />
              </Drawer>
            )}
          />
          <Route
            path={`${PROFESSIONAL_INFO_FORM}/:id`}
            render={(props) => (
              <Drawer
                onClose={this.closeDrawer}
                withCancelConfirmation
                isOpen
              >
                <ProfessionalInformation
                  entityId={props.match.params.id}
                  onClose={this.closeDrawer}
                />
              </Drawer>
            )}
          />
          <Route
            path={`${STRUCTURE_INFO_FORM}/:id`}
            render={(props) => (
              <Drawer
                onClose={this.closeDrawer}
                withCancelConfirmation
                isOpen
                noFill
              >
                <StructuresInformation
                  entityId={props.match.params.id}
                  onClose={this.closeDrawer}
                />
              </Drawer>
            )}
          />
          <Route
            path={`${COLLAB_INFO_DRAWER}/:entityId`}
            render={(props) => (
              <Drawer
                onClose={() => this.updateAndClose(props.match.params.entityId)}
                isOpen
                noFill
              >
                <CollaboratorsInformation
                  entityId={props.match.params.entityId}
                  onClose={() => this.updateAndClose(props.match.params.entityId)}
                />
              </Drawer>
            )}
          />
        </Switch>
        <MyAccount
          openPhotoModal={this.toogleImagePopin}
          myUserDetails={this.props.myUserDetails}
          myIdentity={this.props.myIdentity}
          pseudo={this.state.myPseudo}
        />
        <MyProInfo
          myUserDetails={this.props.myUserDetails}
          openDrawer={this.openDrawer}
          updateNeededByEntity={this.state.updateNeededByEntity}
          updateCollaborateurStatut={this.updateCollaborateurStatut}
        />
        <Footer />
      </div>
    );
  }
}

export default connect((state) => ({
  myIdentity: state.user.myIdentity,
}), { updateMyIndentity })(withRouter(AccountHome));
